import { getMessages } from '../../../../../../../store/constants';

export const CARD_SUBCARD_CREATE = getMessages().getText('card_form_subcard_create');
export const CARD_SUBCARD_CREATE_FOOTER = getMessages().getText('card_form_subcard_create_footer');
export const CARD_SUBCARD_SEARCH = getMessages().getText('card_form_subcard_search');
